import { render, staticRenderFns } from "./RecordsView.vue?vue&type=template&id=edf1c692&scoped=true&lang=html&"
import script from "./RecordsView.vue?vue&type=script&lang=js&"
export * from "./RecordsView.vue?vue&type=script&lang=js&"
import style0 from "./RecordsView.vue?vue&type=style&index=0&id=edf1c692&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf1c692",
  null
  
)

export default component.exports